import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import { TextfieldElement,  withCoursePortalApi} from "cw-styleguide-react";

class CourseGroupsArchiveModal extends Component {


  /**
   * constructor.
   * @param props
   */
  constructor(props) {
    super(props);

    // Set the initial state..
    this.state = {
      "courses": "",
      "courseGroupName":"",
      loaded: false
    }

    this.handleChangeCourseGroupName = this.handleChangeCourseGroupName.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.show !== prevProps.show) {
      this.setState({
        "courseGroupName": "",
      })
    }
  }

  handleChangeCourseGroupName(event) {

    this.setState({
      "courseGroupName": event.target.value,
    })
  }

  render() {
    if (!this.props.show) {
      return null;
    }
    return (
      <div className="modal modal--open" role={'dialog'} aria-modal={'true'}>
        <div className="modal__content">
          <header>
            <div className="header__content">
              {this.props.title}
            </div>
            <button className="button--secondary button--icon icon--cross" onClick={this.props.onCancel}>
              {this.props.t('styleguide:close')}&nbsp;<span className={'visually-hidden'}> {this.props.title} {this.props.t('styleguide:modal')}</span>
            </button>
          </header>
          <main className="content__content">


            <div className="form-wrap">
             <div dangerouslySetInnerHTML={{
                __html: this.props.html
              }}/>

              {/* Venue name */}
              <TextfieldElement size={'medium'} label={this.props.t('local:view.courseGroups.manage.modals.archive.textfieldLabel')}
                                id={'courseGroupName'}
                                required={true}
                                name={'courseGroupName'}
                                value={this.state.courseGroupName}
                                onChange={this.handleChangeCourseGroupName}
                                onKeyPress={this.context.preventDefaultOnEnter}/>

              <div className="form__footer">
                <button className="button button--secondary form__button-cancel" onClick={this.props.onCancel} aria-label={this.props.ariaLabelCancel}>{ this.props.t('styleguide:forms.cancel')}</button>
                <button disabled={this.state.courseGroupName !== this.props.courseGroupName}   className="button form__button-submit" onClick={this.props.onConfirm}  aria-label={this.props.ariaLabelConfirm}>{this.props.t('styleguide:forms.confirm')}</button>
              </div>
            </div>

          </main>

        </div>
      </div>
    )
  }
}

export default withCoursePortalApi(process.env)(withTranslation(['styleguide'])(CourseGroupsArchiveModal));
